import { Transform } from 'class-transformer';
import { IsIn, IsMongoId, IsNotEmpty, IsOptional, MaxLength } from 'class-validator';
import { sanitizeString } from '../utils';
import { AddressType } from './address-type.enum';

/**
 * DTO to create an address for an Account
 */
export class AccountAddressDto {
  /**
   * Stringified ObjectId. This field would exist if the address was already saved.
   */
  @IsOptional()
  @IsMongoId()
  public id?: string;

  /**
   * Name
   */
  @IsOptional()
  @Transform(({ value }) => sanitizeString(value))
  @MaxLength(255)
  public name?: string;

  /**
   * Type of account address. Can be Default or Pickup
   */
  @IsIn([AddressType.Default, AddressType.Pickup])
  public addressType: AddressType;

  /**
   * Street with house number
   */
  @IsNotEmpty()
  @Transform(({ value }) => sanitizeString(value))
  @MaxLength(255)
  public street: string;

  /**
   * City
   */
  @IsNotEmpty()
  @Transform(({ value }) => sanitizeString(value))
  @MaxLength(255)
  public city: string;

  /**
   * Country
   */
  @IsNotEmpty()
  @Transform(({ value }) => sanitizeString(value))
  @MaxLength(255)
  public country: string;

  /**
   * State
   */
  @IsOptional()
  @Transform(({ value }) => sanitizeString(value))
  @MaxLength(255)
  public state?: string;

  /**
   * Zip code
   */
  @IsNotEmpty()
  @Transform(({ value }) => sanitizeString(value))
  @MaxLength(20)
  public zipCode: string;

  /**
   * Additional descriptions for the street
   */
  @IsOptional()
  @MaxLength(255)
  @Transform(({ value }) => sanitizeString(value))
  public streetDescription?: string;
}
